import { useEffect } from 'react';
import { ModalBody } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';


const ConfirmSave = (props) => {
    const { confirmationPopup, onCloseConfirmation, promptID, otherData, handleSaveStatus } = props;
    return (
        <Modal show={confirmationPopup} onHide={onCloseConfirmation} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal">
            <ModalBody>
                <div className='d-flex justify-content-between delete-header align-items-center mb-12 p-0'>
                    <p className="heading dark-clr fs-14">Confirm Action?</p>
                    <i className='icon-x-cros fs-20 dark-clr' onClick={onCloseConfirmation}></i>
                </div>
                <div className='undo-body p-0'>
                    <div className='ar-alert d-flex mb-0 gap-1'>
                        <i className='icon-alert mt-1'></i>
                        <p className='text'>A prompt is already active for this note type. Saving this will disable the previous one.</p>
                    </div>
                </div>
            </ModalBody>

            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onCloseConfirmation} >Cancel</button>
                <button className='btn btn-validate px-10 h-100' onClick={() => handleSaveStatus(otherData.EHRTemplateID, otherData.aiConfigurationId, true)}>Save</button>
            </div>
        </Modal>
    )
}

export default ConfirmSave